import React, { useContext } from 'react';
import { Context } from 'components/Store';
import GrowUIFormField from 'components/Forms/GrowUIFormField';
import { Input } from '@agconnections/grow-ui';

const TaxId = () => {
  const [{ isEnableInfoTabEdit }] = useContext(Context);
  return (
    <GrowUIFormField
      control={Input}
      type="text"
      id="propertyTaxId"
      name="propertyTaxId"
      label="Tax ID"
      placeholder="Enter tax ID"
      disabled={!isEnableInfoTabEdit}
    />
  );
};

export default TaxId;
